import { docViewerReducer } from "@store/doc-viewer/doc-viewer.reducer";
import { thirdPartyReducer } from "@store/third-party/third-party.reducer";
import { aiInsightReducer } from "@store/ai-insights/ai-insight.reducer";
import { globalReducers } from "@store/global/global.reducers";

export const appReducers = {
	docViewer: docViewerReducer,
	thirdParty: thirdPartyReducer,
	aiInsight: aiInsightReducer,
	global: globalReducers
};
